// extracted by mini-css-extract-plugin
export default {"container_footer":"Footer_container_footer__Xct87","container_social":"Footer_container_social__z7n+j","container_footer_description":"Footer_container_footer_description__83ZRU"};